import React from "react";
import ModalBaseView from "../../../../shared-components/lexus/styles/organisms/Modal";
import Text from "../../../../shared-components/lexus/styles/atoms/Text";
import Icon from "../../../../shared-components/lexus/styles/atoms/Icon";
import * as ModalStyles from "../../../../shared-components/lexus/styles/organisms/Modal.styles";
import Button from "../../../../shared-components/lexus/styles/atoms/Button";
import type { ModalViewType } from "../../../../../common-deprecated/types/CommonTypes";
import { UscLabel, useUscLabel } from "../../../utils/labels";
import { useUscSelector } from "../../../redux/store";
import * as Styles from "./UscCarDeliveryInfoModal.styles";
import Badge from "../styles/atoms/Badge";
import type { UscCarDeliveryInfoModalType } from "../../../utils/modalConstants";
import { trackCarDeliveryCloseInfoModal, trackCarDeliveryMoreInfoClick } from "../../../utils/tracking";

const UscCarDeliveryInfoModal = (props: ModalViewType<UscCarDeliveryInfoModalType>): JSX.Element | null => {
    const { show, close, modalSettings } = props;

    const bulletItems = useUscLabel("uscCarDeliveryInfoBullets").split(";");
    const carDeliveryInfoUrl = useUscSelector((state) => state.uscSettings.carDeliveryInfoUrl);
    const uscEnv = useUscSelector((state) => state.vehicle.type);

    const closeLabel = useUscLabel("uscCarDeliveryInfoMoreClose");

    return (
        <ModalBaseView
            modalIdType={modalSettings.type}
            onClose={close}
            size="fitcontent-height"
            show={show}
            disableOutsideClick
            dialogLabelId="uscBasketDetailsTitle"
            dialogDescId="uscBasketDetailsDesc"
        >
            <ModalStyles.Header noBorder>
                <Text tag="h2" variant="h4">
                    <UscLabel label="uscCarDeliveryInfoTitle" />
                </Text>
                <ModalStyles.Button
                    type="button"
                    onClick={() => {
                        trackCarDeliveryCloseInfoModal(uscEnv);
                        close();
                    }}
                    aria-label={closeLabel}
                >
                    <Icon variant="close" />
                </ModalStyles.Button>
            </ModalStyles.Header>
            <ModalStyles.Body>
                <Badge variant="pill-small">
                    {" "}
                    <UscLabel label="uscCarDeliveryInfoCashOnly" />
                </Badge>
                <Text variant="h5" tag="h5" spacing={{ my: "spacing-1" }}>
                    <UscLabel label="uscCarDeliveryInfoHeader" />
                </Text>
                <Styles.Description>
                    <UscLabel label="uscCarDeliveryInfoIntro" />
                    <ol role="list">
                        {bulletItems.map((item) => (
                            <li key={item}>
                                <Text variant="paragraph-body-regular">{item}</Text>
                            </li>
                        ))}
                    </ol>
                </Styles.Description>
                <Styles.Description>
                    <UscLabel label="uscCarDeliveryInfoDescription" />
                </Styles.Description>
                {carDeliveryInfoUrl && (
                    <Button
                        variant="link"
                        href={carDeliveryInfoUrl}
                        onClick={() => {
                            trackCarDeliveryMoreInfoClick(uscEnv);
                        }}
                    >
                        <UscLabel label="uscCarDeliveryInfoMoreInfo" />
                    </Button>
                )}
                <Styles.Footer>
                    <Button
                        variant="outline"
                        onClick={() => {
                            trackCarDeliveryCloseInfoModal(uscEnv);
                            close();
                        }}
                        aria-label={closeLabel}
                    >
                        Close
                    </Button>
                </Styles.Footer>
            </ModalStyles.Body>
        </ModalBaseView>
    );
};
export default UscCarDeliveryInfoModal;
